/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { TagDto } from './tag-dto';
 /**
 *
 *
 * @export
 * @interface TagPaginatedResponseDto
 */
export interface TagPaginatedResponseDto {

    /**
     * @type {Array<TagDto>}
     * @memberof TagPaginatedResponseDto
     */
    data: Array<TagDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof TagPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
